<template>
  <div class="tab_simcard_devices">
    <div class="response_table" v-if="simcard_list.length > 0">
      <div class="header_simcards">
        <h4 class="title">{{ title }}</h4>
      </div>
      <table>
        <thead>
          <tr>
            <th scope="col">
              mno_name
            </th>
            <th scope="col">
              msisdn
            </th>
            <th scope="col">
              imsi
            </th>
            <th scope="col">
              iccid
            </th>
            <th scope="col">
              status
            </th>
            <th scope="col">
              ts_status_update
            </th>
            <th scope="col">
              ts_update
            </th>
          </tr>
        </thead>
        <tbody>
        <router-link
            v-for="(sim,key) in sims_list"
            :key="key"
            :to="go_to(sim.imsi)"
        >
          <tr class="pointer link">

            <td data-label="mno_name">{{ sim.mno }}</td>
            <td data-label="msisdn">{{ sim.number }}</td>
            <td data-label="imsi">{{ sim.imsi }}</td>
            <td data-label="iccid">{{ sim.iccid }}</td>
            <td data-label="status">
              <span class="badge" :class="global_status_color(+sim.status)">
                {{ translate(global_status_text(+sim.status)) }}
              </span>
            </td>
            <td data-label="ts_status_update">{{ get_date(sim.ts_status_update) }}</td>
            <td data-label="ts_update">{{ get_date(sim.ts_update) }}</td>
          </tr>
        </router-link>

        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

export default {
  name: 'simcard_list',
  props: ['title', 'simcard_list'],
  computed:{
    sims_list(){
      let list = this.simcard_list

      if (this.sims_sort === 'asc') {
        list.sort((a, b) => a.ts_sync < b.ts_sync ? 1 : -1)
      }else{
        list.sort((a, b) => a.ts_sync > b.ts_sync ? 1 : -1)
      }

      return list
    }
  },
  methods: {
    go_to (imsi) {
      return {path: '/simcard_devices/' + imsi}
    },
  },
}
</script>
<style lang='scss' scoped>
  .tabs-component-panel .tab_simcard_devices{
    .header_simcards{
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
      .title{
        font-size: 12px;
        line-height: 120%;
        font-weight: bold;
        margin: 0;
      }
      .switch{
        font-size: 12px;
        line-height: 120%;
      }
    }
    .response_table{
      padding: 0;
      table tr {
        background-color: white;
        .link{
          .icon{
            font-size: 18px;
          }
        }
      }
      h4.block_title{
        margin: 0 0 15px;
      }
    }
  }
  .pointer{
    cursor: pointer;
  }
 </style>
